import React, { useState } from "react";
import axios from "axios";


const useNewsType = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [newsTypeOption, setNewsTypeOption] = useState([])
    const getNewsTypeOption = (params) => {
        axios.get('/system/news/type', {
            params:params
        })
            .then((response) => {
                let data = response.data?.data
                data = data.map((value)=>{
                    return {
                        label :value?.news_type_name,
                        value :value?.news_type_id,
                        ...value
                    }
                })
                setNewsTypeOption(data)
            });
    }
    const getNewsTypeData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/system/news/type', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postNewsTypeData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/system/news/type',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchNewsTypeData = (data) => {
        
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/system/news/type',
            
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteNewsTypeData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/system/news/type',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        newsTypeOption: newsTypeOption,
        NewsTypeData: data,
        getNewsTypeData,
        postNewsTypeData,
        patchNewsTypeData,
        deleteNewsTypeData,
        getNewsTypeOption
    }
}
export { useNewsType }
